export default __webpack_public_path__ + "static/media/foto_medico.21e683b3.png";